import React from 'react';

export function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
    className: 'root-deal-page-tabs__tab',
  };
}